<template>
  <div class="card">
    <div class="card-body">
      <div id="smartwizard" class="forms-wizard-vertical">
        <ul class="forms-wizard">
          <li>
            <a href="#step-1">
              <em>1</em>
              <span>Initial Details</span>
            </a>
          </li>
          <li>
            <a href="#step-2">
              <em>2</em>
              <span>Choose Files</span>
            </a>
          </li>
          <li>
            <a href="#step-3">
              <em>3</em>
              <span>Add Notes</span>
            </a>
          </li>
          <li>
            <a href="#step-4">
              <em>4</em>
              <span>Confirm and Upload</span>
            </a>
          </li>
        </ul>
        <div class="form-wizard-content">
            <div id="step-1">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="select_target_group">Company</label>
                            <select id="select_target_group" class="form-control"></select>
                            <div class="error-text"></div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="select_target_subgroup">Department</label>
                            <select id="select_target_subgroup" class="form-control"></select>
                            <div class="error-text"></div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="select_target_user">User</label>
                            <select id="select_target_user" class="form-control"></select>
                            <div class="error-text"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="step-2">
                <div class="card-body">
                  <div class="d-flex">
                    <upload-file-target :id="'file_input'" style="flex-basis: 100%"></upload-file-target>
                  </div>
                </div>
            </div>
            <div id="step-3">
                <div class="card-body">Step3</div>
            </div>
            <div id="step-4">
                <div class="card-body">Step4</div>
            </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
        <div class="d-flex align-items-center justify-content-between w-100">
            <div>
                <button id="reset-btn" class="btn btn-light" type="button" @click="swReset">Reset</button>
            </div>
            <div class="btn-group">
                <button id="prev-btn" class="btn btn-danger" type="button" @click="swPrev">Previous</button>
                <button id="next-btn" class="btn btn-success" type="button" @click="swNext">Next</button>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import UploadFileTarget from '../upload-file/upload-file-target'

export default {
    mounted () {
      //Maybe should drop the plugin and use vue routing for wizard??
        this.sw.smartWizard({
            selected: 0,
            transitionEffect: 'fade',
            toolbarSettings: {
                toolbarPosition: 'none'
            },
            showStepURLhash: false
        });
    },
    computed: {
        sw() {
            return $('#smartwizard');
        }
    },
    components: {
      UploadFileTarget
    },
    methods: {
        swNext() {
            this.sw.smartWizard('next');
            return true;
        },
        swPrev() {
            this.sw.smartWizard('prev');
            return true;
        },
        swReset() {
            this.sw.smartWizard('reset');
            return true;
        }
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/user/upload-file-panel.vue